<template>
    <div class="row">
        <div class="col-xs-12">
            <slot></slot>
        </div>
        <div class="col-xs-12 trivia-scratch-out">
            <div class="scratch-out-options">
                <div
                    v-for="option in question.options"
                    :key="option.id"
                    class="scratch-out-item"
                    :class="itemClass(option.id)"
                    @click="toggleOption(option.id)"
                >
                    <p class="scratch-out-text" v-html="option.text"></p>
                </div>
                <div v-if="questionAnswered" class="trivia-result-indicator">
                    <check v-if="isCorrect" class="svg-icon large"></check>
                    <incorrect v-else class="svg-icon large"></incorrect>
                </div>
            </div>
            <div class="scratch-out-submit">
                <button
                    v-if="!questionAnswered"
                    class="btn primary-btn"
                    :disabled="selectedOptions.length === 0"
                    @click="$emit('answer', selectedOptions)"
                >
                    {{ $t("CONTINUE") }}
                </button>
            </div>
        </div>
    </div>
</template>
<!----------------------------------------------------------------------------->
<script>
import {xor} from "lodash";
import Check from "Components/Svg/Check";
import Incorrect from "Components/Svg/Incorrect";

export default {
    name: "TriviaScratchOut",

    components: {Check, Incorrect},

    props: {
        question: {type: Object, required: true},
        questionAnswered: {type: Boolean, required: true},
        correct: {default: null},
    },

    data() {
        return {
            selectedOptions: [],
        };
    },

    computed: {
        isCorrect() {
            return xor(this.selectedOptions, this.correct).length === 0;
        },
    },

    methods: {
        toggleOption(optionId) {
            if (this.questionAnswered) return;
            const index = this.selectedOptions.indexOf(optionId);
            if (index === -1) {
                this.selectedOptions.push(optionId);
            } else {
                this.selectedOptions.splice(index, 1);
            }
        },
        itemClass(optionId) {
            if (!this.questionAnswered) {
                return {selected: this.selectedOptions.includes(optionId)};
            }
            const userSelected = this.selectedOptions.includes(optionId);
            const isCorrect = this.correct.includes(optionId);
            return {
                "correct-hit": userSelected && isCorrect,
                incorrect: userSelected !== isCorrect,
                "was-selected": userSelected,
            };
        },
    },
};
</script>
<!----------------------------------------------------------------------------->
<style lang="scss" type="text/scss"></style>
